module.exports = __webpack_public_path__ + "static/media/Noirden-Light-oblique.22fc4a3d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Noirden-Light-oblique.woff2
// module id = 3354
// module chunks = 68